import { Component, uiEvent } from "@kluntje/core";
import { find } from "@kluntje/js-utils/lib/dom-helpers";
import { CookieSettingsOverlay } from "Components/wec-m-cookie-settings-overlay/wec-m-cookie-settings-overlay";

export class WECConsentSettingsOverlayToggle extends Component {
  settingsOverlay?: CookieSettingsOverlay | null;

  afterComponentRender() {
    this.settingsOverlay = find<CookieSettingsOverlay>(document.body, "#cookie-settings-overlay");
  }

  @uiEvent("this", "click")
  handleClick() {
    if (this.settingsOverlay) {
      this.settingsOverlay.open();
    }
  }
}

customElements.define("wec-e-consent-settings-overlay-toggle", WECConsentSettingsOverlayToggle);
